export const CountdownPanel = ({ isLive, days, hours, minutes, seconds }) => (
  <div className="mt-8 border border-[#E5E0D8] bg-white p-6">
    <p className="label-eyebrow text-[#555]">{isLive ? "Ends in" : "Auction ended"}</p>
    <div className="mt-3 grid grid-cols-4 gap-2 text-center" data-testid="countdown">
      {[
        { v: days, l: "Days" },
        { v: hours, l: "Hrs" },
        { v: minutes, l: "Min" },
        { v: seconds, l: "Sec" },
      ].map((u) => (
        <div key={u.l} className="border border-[#E5E0D8] py-3">
          <p className="font-mono-aam text-3xl text-[#1E3A8A]">
            {String(u.v).padStart(2, "0")}
          </p>
          <p className="label-eyebrow text-[#555] mt-1">{u.l}</p>
        </div>
      ))}
    </div>
  </div>
);
